import { render, staticRenderFns } from "./PlaqueList.vue?vue&type=template&id=cf631128&scoped=true"
import script from "./PlaqueList.vue?vue&type=script&lang=js"
export * from "./PlaqueList.vue?vue&type=script&lang=js"
import style0 from "./PlaqueList.vue?vue&type=style&index=0&id=cf631128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf631128",
  null
  
)

export default component.exports